import * as React from 'react';
import s from '../RequestCall.scss';
import { Translation } from 'react-i18next';
import { RootStore, withInjectedRootStore } from 'providers';
import classNames from 'classnames';
import { Heading, Text } from '@wix/design-system';
import { UiProvider } from 'providers/UiProvider';
import { FormLayout } from './Form/FormLayout';
import { FormButtons } from './Form/FormButtons';
import { EnterpriseModalClickSource } from 'services/BiLogger/BiLoggerTypes';

interface ContactDetails {
  rootStore: RootStore;
  clickSource?: EnterpriseModalClickSource;
  onCancelClick(): void;
  showSuccsessMessage(s: boolean): void;
}

const formInputLabels = {
  firstName: 'premium_plan.business_enterprise.request_call_form.first_name',
  lastName: 'premium_plan.business_enterprise.request_call_form.last_name',
  bussinessEmail: 'premium_plan.business_enterprise.request_call_form.email',
  phoneNumber: 'premium_plan.business_enterprise.request_call_form.phone',
  company: 'premium_plan.business_enterprise.request_call_form.company',
  jobTitle: 'premium_plan.business_enterprise.request_call_form.job_title',
  messageBox: 'premium_plan.business_enterprise.request_call_form.message_box',
};

const ContactDetailsComp: React.FC<ContactDetails> = ({
  rootStore,
  clickSource,
  onCancelClick,
  showSuccsessMessage,
}) => {
  const {
    appContext: { biLogger },
    planType,
  } = rootStore!.appStore;
  React.useEffect(() => {
    biLogger.logRequestCallPopupLoad({
      ppType: planType,
      clickType: clickSource,
    });
  }, []);
  return (
    <UiProvider>
      {({ themeName }) => (
        <Translation>
          {(t) => (
            <>
              <div
                className={s.contactFormHeader}
                data-testid='contact-details'
              >
                <Heading appearance='H2'>
                  {t('premium-purchase-plan.enterprise_modal.title')}
                </Heading>
                <Text
                  className={classNames(s.subTitle, themeName)}
                  weight='thin'
                  size='medium'
                >
                  {t('premium-purchase-plan.enterprise_modal.subtitle')}
                </Text>
              </div>
              <FormLayout
                showSuccsessMessage={showSuccsessMessage}
                onCancelClick={onCancelClick}
                formInputLabels={formInputLabels}
                cta={<FormButtons />}
                disclaimerKey='premium_plan.business_enterprise.request_call_form.disclaimer'
              />
            </>
          )}
        </Translation>
      )}
    </UiProvider>
  );
};

export default withInjectedRootStore(ContactDetailsComp);
